<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { NodeData } from '../types/flow-types';
	import { resolveSetVariableSummary } from '../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: variableName = data.variable?.name || 'variable';
	$: variableValue = data.variable?.value !== undefined ? String(data.variable.value) : '...';
	$: summary = resolveSetVariableSummary(data);
</script>

<BaseNode
	{id}
	type="setVariable"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={summary}
	nodeTypeLabel="Set variable"
	{...$$restProps}
>
	<div class="variable-content">
		<div class="variable-assignment">
			<span class="var-name">{variableName}</span>
			<span class="equals">=</span>
			<span class="var-value">{variableValue}</span>
		</div>
	</div>
</BaseNode>

<style>
	.variable-content {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.variable-assignment {
		display: flex;
		align-items: center;
		gap: 8px;
		font-family: 'Courier New', monospace;
		font-size: 0.875rem;
	}

	.var-name {
		color: #f97316;
		font-weight: 600;
	}

	.equals {
		color: var(--flow-slot-muted);
	}

	.var-value {
		color: var(--flow-slot-strong);
		font-weight: 500;
	}
</style>
